import React from 'react';
import { Provider } from 'react-redux';
import { store } from '../../../../redux/store';
import ManageAccessPage from '../../../organisms/manage_access/ManageAccessPage';

// Thin wrapper — all layout and behaviour live in the shared ManageAccessPage.
const IndexPage = () => (
  <Provider store={store}>
    <ManageAccessPage materialType="checklists" />
  </Provider>
);

export default IndexPage;
